<template>
    <div class="dynamic"
         :class="wrapperClass">
        <div class="title">{{ header }}</div>
        <div class="dynamic-date">
            <div class="date-block">
                <div class="date">{{ displayDate }}</div>
                <div class="time">{{ displayTime }}</div>
            </div>
            <div class="dynamic-controls">
                <div class="prev"
                     :disabled="!!controlsDisabled"
                     @click="decreaseDynamic"><i class="fa fa-chevron-left" aria-hidden="true"></i></div>
                <div class="next"
                     :disabled="!!controlsDisabled"
                     @click="increaseDynamic"><i class="fa fa-chevron-right" aria-hidden="true"></i></div>
            </div>
        </div>
        <div class="field-list">
            <div class="field">
                <input type="number" min="0" max="999" maxlength="3"
                       v-model="days"><span>дней</span>
            </div>
            <div class="field">
                <input type="number" min="0" max="23" maxlength="2"
                       v-model="hours"><span>час</span>
            </div>
            <div class="field">
                <input type="number" min="0" max="59" maxlength="2"
                       v-model="minutes"><span>мин</span>
            </div>
        </div>
    </div>
</template>

<script>
    import constants from '@/constants';
    import utils from '@/utils';
    import moment from 'moment';

    export default {
        name: 'DateDynamic',

        props: ['mode'],

        components: {},

        data() {
            return {
                days: 0,
                hours: 0,
                minutes: 0,

                controlsDisabled: false
            }
        },

        computed: {
            wrapperClass() {
                return this.mode === constants.mode.natal ?
                        'dynamic-natal' : 'dynamic-dop';
            },

            header() {
                let header;

                switch (this.mode) {
                    case constants.mode.transit:
                        header = 'Динамика транзита';
                        break;
                    case constants.mode.direction:
                        header = 'Динамика дирекции';
                        break;
                    case constants.mode.progression:
                        header = 'Динамика прогрессии';
                        break;
                    case constants.mode.multimap:
                        header = 'Динамика мультикарты';
                        break;
                    default:
                        header = 'Динамика даты рождения';
                }

                return header;
            },

            shift() {
                return this.days * 24 * 60 * 60
                        + this.hours * 60 * 60
                        + this.minutes * 60;
            },

            dynamic() {
                let dynamic;

                switch (this.mode) {
                    case constants.mode.transit:
                        dynamic = this.$store.getters.transitDynamic;
                        break;
                    case constants.mode.direction:
                        dynamic = this.$store.getters.directionDynamic;
                        break;
                    case constants.mode.progression:
                        dynamic = this.$store.getters.progressionDynamic;
                        break;
                    case constants.mode.multimap:
                        dynamic = this.$store.getters.multimapDynamic;
                        break;
                    default:
                        dynamic = this.$store.getters.natalDynamic;
                }

                return dynamic;
            },

            shiftedDate() {
                let date = this.mode === constants.mode.natal ?
                        this.$store.getters.inputDate :
                        this.$store.getters.transitInputDate;
                let time = this.mode === constants.mode.natal ?
                        this.$store.getters.inputTime :
                        this.$store.getters.transitInputTime;

                return moment(utils.concatDateAndTime(date, time), 'DD.MM.YYYY HH:mm:ss')
                        .add(this.dynamic, 'seconds');
            },

            displayDate() {
                return this.shiftedDate.format('DD.MM.YYYY');
            },

            displayTime() {
                return this.shiftedDate.format('HH:mm');
            }
        },

        methods: {
            increaseDynamic() {
                this.changeDynamic(true);
            },

            decreaseDynamic() {
                this.changeDynamic(false);
            },

            async changeDynamic(increase) {
                if (!!this.controlsDisabled)
                    return;
                this.controlsDisabled = true;

                try {
                    await this.$store.dispatch('changeDynamic', {
                        mode: this.mode,
                        shift: !!increase ? this.shift : -this.shift
                    });
                } finally {
                    // Во избежание излишней нагрузки
                    setTimeout(() => {
                        this.controlsDisabled = false;
                    }, 300);
                }
            }
        }
    }
</script>
